import { useContext } from "react";
import { EditValuesContext } from "../contexts/EditValuesContext";

export function EditValues() {
  const value = useContext(EditValuesContext);
  return value;
}
